import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserReportType } from 'src/app/shared/constants/user-report-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { PostProfileDetailsComponent } from '../../../shared/components/post-profile-details/post-profile-details.component';
import { UnblockAccountsComponent } from '../unblock-accounts/unblock-accounts.component';
import { SharedService } from '../../../providers/shared.service';
@Component({
  selector: 'sm-all-deactivated-account',
  templateUrl: './all-deactivated-account.component.html',
  styleUrls: ['./all-deactivated-account.component.scss']
})
export class AllDeactivatedAccountComponent implements OnInit, OnDestroy {
  accountList: any[] = [];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "date",
      columnProperty: "creation_time"
    },
    // {
    //   columnName: "name",
    //   columnProperty: "name"
    // },
    
    {
      columnName: "type",
      columnProperty: "type"
    },
    {
      columnName: "message",
      columnProperty: "reason"
    },
    {
      columnName: "status",
      columnProperty: "block_unblock_status"
    },
   
  ];
  public loader: boolean = false;
  private _apiSub: Subscription;
  clickEventSubscription: Subscription;
  constructor(private _apiService : ApiService,  private _datePipe: DatePipe, private _dialog: MatDialog, private sharedService: SharedService) { 
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    this._apiSub = this._apiService.apiResult.subscribe(resData =>{
     
      if(resData.responseType === SM_CONSTANTS.GET_LATEST_BLOCKED_UNBLOCKED_ACCOUNTS_RESULT){
        console.log(resData);
        this.accountList = resData.result ? resData.result : [];
        this.accountList.forEach((item )=> {
          
          if(item.type == 'user'){
           if(item.block_unblock_status == 1 ){
             item.block_unblock_status = 'Unblocked'
           }
           else if(item.block_unblock_status == 2 ){
             item.block_unblock_status = 'Blocked'
           }
          }
 
          else if(item.type == 'business' ){
           if(item.block_unblock_status == 0 ){
             item.block_unblock_status = 'Blocked'
           }
           else if(item.block_unblock_status == 1 ){
             item.block_unblock_status = 'Unblocked'
           }
          }
          
         })
        this.accountList =     this.accountList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creation_time'])) - (+new 
        Date(dataA['creation_time'])))
 
     )
        this.accountList.map(account => {
          account.creationDate = this._datePipe.transform(account.creationDate, 'MMM d, y');
        });
      }
this.loader = false
    });
  }

  ngOnInit(): void {
    this.loader = true
    this._apiService.getLatestBlockedUnblockedAccounts()
  }

  ngOnDestroy(){
    this._apiSub.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

  viewProfile(rowvalue:any){
    console.log(rowvalue);
    this._dialog.open(PostProfileDetailsComponent, {
      data: rowvalue,
      width: '500px',
      panelClass: 'user-profile-dialog'
    });
    
  }

  unblock(value: any){
    console.log(value);

  
      
     
      this._dialog.open(UnblockAccountsComponent, {
        height: '350px',
        disableClose: true,
        data: {
          ref: this._dialog,
          data: value
        }
      });
  

   
  }


}
